import Vue from "vue";
import Router from "vue-router";
import * as Store from "../utils/store";
import { supportH5Storage, checkPermission } from "./util";
import bus from "../views/common/bus";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/",
      component: resolve => require(["../views/common/Home.vue"], resolve),
      meta: { title: "自述文件" },
      children: [
        {
          path: "/dashboard",
          component: resolve =>
            require(["../views/page/dashboard/dashboard.vue"], resolve),
          meta: []
        },
        // 人员用户管理
        {
          path: "/useradmin",
          component: resolve => require(["../views/page/useradmin"], resolve),
          meta: ["用户管理", "分组管理"]
        },
        // 模块管理
        {
          path: "/model/financial",
          component: resolve =>
            require(["../views/page/model/financial.vue"], resolve),
          meta: ["模块管理", "文章管理"]
        },
        {
          path: "/model/banner",
          component: resolve =>
            require(["../views/page/model/banner.vue"], resolve),
          meta: ["模块管理", "轮播管理"]
        },
        {
          path: "/model/contact",
          component: resolve =>
            require(["../views/page/model/contact.vue"], resolve),
          meta: ["模块管理", "联系我们"]
        },
        {
          path: "/model/bottomimg",
          component: resolve =>
            require(["../views/page/model/bottomimg.vue"], resolve),
          meta: ["模块管理", "顶部广告"]
        },
        {
          path: "/model/friendLink",
          component: resolve =>
            require(["../views/page/model/friendLink.vue"], resolve),
          meta: ["模块管理", "友链管理"]
        },
        {
          path: "/model/finacialpage",
          component: resolve =>
            require(["../views/page/model/finacialpage.vue"], resolve),
          meta: ["模块管理", "编辑文章"]
        }

        // {
        //   path: '/model/country',
        //   component: resolve => require(['../views/page/model/country.vue'], resolve),
        //   meta: ['模块管理', '乡村振兴'],
        // },
        // {
        //   path: '/model/special',
        //   component: resolve => require(['../views/page/model/special.vue'], resolve),
        //   meta: ['模块管理', '专委会动态'],
        // },
        // {
        //   path: '/model/specialbrief',
        //   component: resolve => require(['../views/page/model/specialbrief.vue'], resolve),
        //   meta: ['模块管理', '专委会简介'],
        // },
        // {
        //   path: '/model/project',
        //   component: resolve => require(['../views/page/model/project.vue'], resolve),
        //   meta: ['模块管理', '项目申报'],
        // },
        // {
        //   path: '/model/place',
        //   component: resolve => require(['../views/page/model/place.vue'], resolve),
        //   meta: ['模块管理', '产地风采'],
        // },
        // {
        //   path: '/model/cooperator',
        //   component: resolve => require(['../views/page/model/cooperator.vue'], resolve),
        //   meta: ['模块管理', '合作单位'],
        // },
        // {
        //   path: '/model/contact',
        //   component: resolve => require(['../views/page/model/contact.vue'], resolve),
        //   meta: ['模块管理', '联系我们'],
        // },
      ]
    },

    {
      path: "/login",
      component: resolve => require(["../views/page/Login.vue"], resolve)
    }
  ]
});

let roleList = [];
bus.$on("user_role_list", function(list) {
  Store.setUrlList(JSON.stringify(list));
  roleList = list;
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
  } else {
    let pathToCheck = to.path;
    if (roleList.length > 0) {
      checkPermission(roleList, pathToCheck) ? next() : next("/login");
    } else {
      if (supportH5Storage()) {
        if (Store.getUrlList()) {
          roleList = JSON.parse(Store.getUrlList());
        } else {
          next("/login");
        }
        if (!roleList || roleList.length === 0) {
          next("/login");
        } else {
          checkPermission(roleList, pathToCheck) ? next() : next("/login");
        }
      } else {
        // TODO: request url list
        next();
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js